/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListWidgetTemplatesRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'
import {ListWidgetTemplatesResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'


export const listWidgetTemplates = (request: ListWidgetTemplatesRequest, options?: CashRequestOptions) => post<ListWidgetTemplatesRequest, ListWidgetTemplatesResponse>("/2.0/cash/list-widget-templates", request, {...options, rejectOnError: true })